<template>
  <b-container class="mt-5">
    <b-row>
      <b-col>
        <b-card header="Edit event">
          <b-form @submit.prevent="onSubmit">
            <b-form-group id="name-label" label="Name:" label-for="name" label-cols-md="3">
              <b-form-input id="name" v-model="event.name" type="text" required placeholder="Enter event name"></b-form-input>
            </b-form-group>
            <b-form-group label="Allow movie suggestions" label-cols-md="3">
              <b-form-checkbox v-model="event.allowMovieSuggestions" name="allowMovieSuggestions" ></b-form-checkbox>
            </b-form-group>
            <b-form-group id="date-label" label="Date:" label-for="date" label-cols-md="3">
              <b-form-input id="date" v-model="event.datetime" type="datetime-local" required placeholder="Enter event date"></b-form-input>
            </b-form-group>
            <b-form-group id="place-label" label="Place:" label-for="place" label-cols-md="3">
              <b-row>
                <b-col cols="12" md="7">
                  <gmap-autocomplete class="form-control mb-3" v-model="event.eventAddress" placeholder="Enter location" @place_changed="setEventLocation" />
                </b-col>
                <b-col cols="12" md="5">
                  <b-form-group>
                    <b-form-radio-group id="marker-types" v-model="currentMarker" :options="['Event', 'Parking', 'Public Transport']" buttons button-variant="primary"></b-form-radio-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <GmapMap ref="mapping" :center="center" :zoom="14" map-type-id="terrain" style="width: 100%; height: 300px" @click="setMarker">
                  <GmapMarker :key="index" v-for="(m, index) in event.markers" :position="m.position" :label="index" :clickable="true" :draggable="true" @click="center=m.position" />
                </GmapMap>
              </b-row>
            </b-form-group>
            <b-button type="submit" variant="primary">Update Event!</b-button>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col>
        <b-card header="Participants">
          <h4>Going:</h4>
          <ul>
            <li v-for="(p, index) in goingParticipants" :key="index" class="mt-2">{{ p.name }}</li>
          </ul>
          <h4>Not going:</h4>
          <ul>
            <li v-for="(p, index) in notGoingParticipants" :key="index" class="mt-2">{{ p.name }}</li>
          </ul>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col>
        <b-card header="Suggested and selected movies">
          <b-row li v-for="(movie, index) in sortedMovies" :key="index" class="mt-2">
            <b-col cols="12" md="2">
              <b-img thumbnail fluid :src="movie.cover" />
            </b-col>
            <b-col cols="12" md="10">
              <h2 class="mb-0">{{ movie.title }}</h2>
              <p class="mt-0 mb-0"><small>TMDB: {{ movie.tmdbVoteAverage }}/10 ({{ movie.tmdbVoteCount }} votes) / Event: {{ movie.votes.length }}</small></p>
              <p>{{ movie.description }}</p>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {mapState} from 'vuex'
import {gmapApi} from 'vue2-google-maps'
import firebase from 'firebase'

export default {
    mounted() {
      this.eventId = this.$route.params.eventId
      const eventRef = firebase.firestore().doc(`/events/${this.eventId}`);
      eventRef.get().then(doc => {
          let event = doc.data()
          this.center = {
            lat: event.eventLocation.latitude,
            lng: event.eventLocation.longitude,
          }
          this.event = event
          this.event.markers = {
            'Event': { position: {lat: event.eventLocation.latitude, lng: event.eventLocation.longitude} },
            'Parking': { position: {lat: event.parkingLocation.latitude, lng: event.parkingLocation.longitude} },
            'Public Transport': { position: {lat: event.publicTransportLocation.latitude, lng: event.publicTransportLocation.longitude} },
          }

          this.movies = []
          eventRef.collection('/movies').onSnapshot(ds => {
            ds.docs.forEach(d => {
                this.movies.push(d.data())
            })
          })
          this.participants = []
          eventRef.collection('/participants').onSnapshot(ds => {
            ds.docs.forEach(d => {
                this.participants.push(d.data())
            })
          })
      })
    },
    computed: {
      google: gmapApi,
      ...mapState(['user', 'displayName']),
      sortedMovies() {
        return this.movies.sort((m1, m2) => {
          return m1.title < m2.title ? -1 : 1
        })
      },
      goingParticipants() {
          return this.participants.filter(p => p.going == 'yes')
      },
      notGoingParticipants() {
          return this.participants.filter(p => p.going == 'no')
      }
    },
    data() {
      return {
        eventId: '',
        event: {
          allowMovieSuggestions: false,
          name: '',
          date: '',
          center: {lat: 0, lng: 0},
          eventAddress: '',
          markers: {
            'Event': {},
            'Parking': {},
            'Public Transport': {},
          },
        },
        center: {lat: 0, lng: 0},
        currentMarker: 'Event',
        getMap:this.$refs.mapping,
        description:'',
        latLng: {},
        movies: [],
        participants: [],
        place: null
      }
    },
    methods: {
      async onSubmit() {
        const evt = {
          allowMovieSuggestions: this.allowMovieSuggestions,
          datetime: this.date,
          eventAddress: this.eventAddress,
          eventLocation: new firebase.firestore.GeoPoint(this.event.markers['Event'].position.lat, this.event.markers['Event'].position.lng),
          name: this.name,
          organizerId: this.user.uid,
          organizer: this.displayName,
          parkingLocation: new firebase.firestore.GeoPoint(this.event.markers['Parking'].position.lat, this.event.markers['Parking'].position.lng),
          publicTransportLocation: new firebase.firestore.GeoPoint(this.event.markers['Public Transport'].position.lat, this.event.markers['Public Transport'].position.lng),
        }
        firebase.firestore().collection('events').doc(this.eventId).update(this.event).then(() => {
            this.$router.push(`/event/${this.eventId}`)
        })

      },
      setDescription(description){
        this.description = description
      },

      setEventLocation(place){
        this.event.markers['Event'] = {
          position: {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          }
        }
        const geocoder = new this.google.maps.Geocoder()
        geocoder.geocode({
          location: {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          }
        }, (res, status) => {
          this.eventAddress = res[0].formatted_address
        })
        this.$refs.mapping.$mapPromise.then((map) => {
          map.panTo(this.event.markers['Event'].position)
        })
        this.currentMarker = 'Parking'
      },
      setCurrentMarkerType(type) {
        this.currentMarker = type
      },

      setMarker(e) {
        this.event.markers[this.currentMarker] = {
          position: {
            lat: e.latLng.lat(),
            lng: e.latLng.lng()
          }
        }
        switch(this.currentMarker) {
          case 'Event':
            this.currentMarker = 'Parking'
            break
          case 'Parking':
            this.currentMarker = 'Public Transport'
            break
          case 'Public Transport':
            this.currentMarker = 'Event'
            break
        }
      }
    }
}
</script>

<style>
#map {
  display: inline-block;
  min-height: 400px;
}
</style>